import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { Student } from 'types';
import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

const t = (key) => translate('ui', key);

const useStyles = makeStyles((theme: Theme) => {
  return {
    section: {
      backgroundColor: 'white',
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(8),
    },
    border: {
      border: `1px solid ${(theme.palette as any).grey[600]}`,
    },
    p4: {
      padding: theme.spacing(4),
    },
    studentList: {
      '& .MuiTableCell-root': {
        border: `1px solid ${(theme.palette as any).grey[600]}`,
        padding: theme.spacing(2),
      },
    },
  };
});

const SimpleStudentsList = (props: { students: Student[] }): React.ReactElement => {
  const classes = useStyles();

  return (
    <section className={clsx(classes.section, props.students.length === 0 ? classes.border : '')}>
      {props.students.length === 0 && (
        <Typography variant="body1" align="center" className={classes.p4}>
          {t('class.studentsNone')}
        </Typography>
      )}
      {props.students.length > 0 && (
        <TableContainer className={classes.studentList}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography variant="body1">{t('class.studentsName')}</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.students.map((student, index) => (
                <TableRow key={student.id + '-' + index}>
                  <TableCell>
                    <Typography variant="body1">{`${student.firstName} ${student.lastName}`}</Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </section>
  );
};

export default SimpleStudentsList;
